import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { minutesToMilliseconds } from '@e3dc-react/shell/Libs/date'
import { UseQueryResult } from '@tanstack/react-query'
import { isFlowTheme } from 'src/Libs/utils'
import { EmobilityWallboxConfigurationDto } from '../dto/wallbox-configuration.dto'
import useWallboxHardwareByStorage from './use-wallbox-hardware-by-storage'
import { useTypedSelector } from 'src/State/RootReducer'
import { usePortalQueries } from 'src/Libs/api'

const useEmobilityWallboxConfigurationQueries = (): UseQueryResult<EmobilityWallboxConfigurationDto | undefined>[] => {
  const { data: hardwareWallboxes } = useWallboxHardwareByStorage()
  const authFetch = useAuthFetchWithResponse()
  const storageId = useTypedSelector(state => state.storage.activeStorage)

  const emobilityEndpoint = process.env.REACT_APP_EMOBILITY_ENDPOINT ?? ''

  return usePortalQueries(
    (hardwareWallboxes ?? []).map(wallbox => ({
      queryKey: ['emobility-wallbox-configuration', storageId, wallbox.number.toString(), wallbox.id.toString()],
      queryFn: async () => {
        const response = await authFetch<EmobilityWallboxConfigurationDto>({
          path: `wallboxes/${storageId}/${wallbox.number}/configuration`,
          endpoint: emobilityEndpoint,
        })
        return response.data
      },
      enabled: !!storageId && isFlowTheme,
      refetchInterval: minutesToMilliseconds(1),
      staleTime: 0,
    }))
  )
}

export default useEmobilityWallboxConfigurationQueries
